import { render, staticRenderFns } from "./Add-Stock.vue?vue&type=template&id=42c45e2e&"
import script from "./Add-Stock.vue?vue&type=script&lang=js&"
export * from "./Add-Stock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports